/**
 * Returns the delay needed due to the animation of a modal opening - attempting to attach to an animating modal
 * can have unpredictable results. As there is no semantic token for the modal transition timing, we're using a
 * hardcoded timing of 350ms. See: https://hubspot.slack.com/archives/C1WG3L3J6/p1738802057277719
 */
export const getAnimationDelay = () => {
  const MODAL_TRANSITION_TIMING = '350ms';
  return parseInt(MODAL_TRANSITION_TIMING.slice(0, MODAL_TRANSITION_TIMING.length - 2), 10) + 100;
};
/**
 * Watches DOM changes for when a specificed elementQuery is matched.
 *
 * @return a promise with the element
 */
export const waitForElementToAppear = ({
  elementQuery,
  requiresModalAnimation = false,
  targetDocument = document
}) => {
  const maybeElement = targetDocument.querySelector(elementQuery);
  if (maybeElement && !requiresModalAnimation) {
    return Promise.resolve(maybeElement);
  }
  return new Promise(resolve => {
    const observer = new MutationObserver(() => {
      const maybeAppearedElement = targetDocument.querySelector(elementQuery);
      if (maybeAppearedElement) {
        if (requiresModalAnimation) {
          setTimeout(() => resolve(maybeAppearedElement), getAnimationDelay());
        } else {
          resolve(maybeAppearedElement);
        }
        observer.disconnect();
      }
    });
    observer.observe(targetDocument, {
      attributes: true,
      childList: true,
      characterData: false,
      subtree: true
    });
  });
};